import { useTranslation } from "react-i18next";
import { classNames } from "primereact/utils";

interface AlertValuesBannerProps {
	/** When "header", compact style next to the + Biometric button; otherwise standalone above content */
	variant?: "standalone" | "header";
}

const AlertValuesBanner = ({ variant = "standalone" }: AlertValuesBannerProps) => {
	const { t } = useTranslation("common");
	const isHeader = variant === "header";

	return (
		<div
			className={classNames(
				"flex align-items-center rounded alert-values-banner",
				isHeader ? "alert-values-banner--header p-2" : "p-2 mb-3 gap-2"
			)}
			role="status"
		>
			<i
				className="pi pi-exclamation-triangle alert-values-banner__icon flex-shrink-0"
				aria-hidden
			/>
			<span className="alert-values-banner__text">
				{t("PARTICIPANT.BIOMETRICS.ALERT_VALUES.CUSTOM_BANNER")}
			</span>
		</div>
	);
};

export default AlertValuesBanner;
